import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { WorkerStatus } from '@nimmsta/ng-commons-lib';

@Pipe({
  name: 'toWorkerStatusBadge',
})
export class WorkerStatusPipe implements PipeTransform {
  private translate = inject(TranslateService);


  transform(workerStatus: WorkerStatus): string {
    let status;
    let badge;
    switch (workerStatus) {
      case WorkerStatus.PAIRED:
        status = 'worker.paired';
        badge = 'paired';
        break;
      case WorkerStatus.ACTIVE:
        status = 'ACTIVE';
        badge = 'active';
        break;
      default:
        status = 'worker.not_paired';
        badge = 'not-paired';
        break;
    }
    const text = this.translate.instant(status);
    return (
      `<div class="badge rounded-pill text-bg-light" translate><div class="dot ${badge}"></div>${text}</div>`
    );
  }
}
